<template>
	<div class="video-player" style="width: 100%; aspect-ratio: 1.65">
		<Video
			v-if="videoSRC"
			class="p-0 no-radius"
			:video-src="videoSRC"
			:videoStreamSrc="videoStreamSrc"
			video-id="embed-video"
			key="embed-video"
			:showMask="false"
			:fcpComplete="fcpComplete"
			:avoid-default-spacing="true"
		></Video>
	</div>
</template>
<script>
	import Video from '~/stan-vue-shared/components/Video'
	export default {
		components: { Video },
		name: 'VideoPlayer',
		data() {
			return {
				videoSRC: undefined,
				videoStreamSrc: undefined,
				fcpComplete: true,
			}
		},
		async mounted() {
			this.videoSRC = this.$route.query.src
			// TODO: Check if stream available, to pass stream URL
			// this.videoStreamSrc = this.videoSRC.replace('.mp4', '.m3u8')

			this.$nextTick(() => {
				this.fcpComplete = true
			})
		},
		methods: {},
	}
</script>
<style lang="scss">
	.video-player::v-deep {
		.video-wrapper {
			video {
				border-radius: 0px !important;
			}
		}
	}

	.p-0 {
		padding: 0px !important;
	}
	#embed-video:focus {
		outline: none;
	}
</style>
